import config from "../config"
const baseUrl = config.base_url + "city/"
export default {
    getCityByProvinceCode: {
        url: baseUrl + "getCityByProvinceCode?key=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9",
        type: "get",
    }
}
